export default __webpack_public_path__ + "static/media/kernel.65a3a3df.png";